import { Component, Input, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'ad-preview',
  template: `
      <div class="add-preview-ver" *ngIf="ad.orientation == 'vertical'">
        <div style="font-size:20px; text-align:center">{{ad.name}}</div>
        <div class='preview-img-ver d-flex align-items-center' style="margin-bottom:20px" *ngIf="ad.type == 2">
            <img [attr.src]="ad.Files[currentSlide].link">
        </div>
        <div class='preview-video-ver' style="margin-bottom:20px" *ngIf="ad.type == 1">
            <video controls autoplay loop [attr.src]="ad.Files[currentSlide].link"></video>
        </div>
      </div>

      <div class="add-preview-horiz" *ngIf="ad.orientation == 'horizontal'">
        <div style="font-size:20px; text-align:center">{{ad.name}}</div>
        <div class='preview-img-horiz d-flex align-items-center' style="margin-bottom:20px" *ngIf="ad.type == 2">
            <img [attr.src]="ad.Files[currentSlide].link">
        </div>
        <div class='preview-video-horiz' style="margin-bottom:20px" *ngIf="ad.type == 1">
            <video  controls autoplay loop [attr.src]="ad.Files[currentSlide].link"></video>
        </div>
      </div>
    `,
    styleUrls:['./devicepreview.scss']
})

export class DevicePreview implements OnInit, OnDestroy {
    @Input() ad: any;
    private currentSlide: number = 0;
    private totalSlides: number = 0;
    private sliderInterval: any  = null;

    constructor() {

    }

    ngOnInit() {

        if (this.sliderInterval) {
            clearInterval(this.sliderInterval);
        }

        this.currentSlide = 0;

        if (this.ad.type == 2) {
            this.totalSlides = this.ad.Files.length;
            this.sliderInterval = setInterval(() => {
                this.nextSlide();
            }, 2000);
        }
    }

    nextSlide() {
        this.currentSlide = (this.currentSlide+1)%this.totalSlides;
    }

    ngOnDestroy() {
        if (this.sliderInterval) {
            clearInterval(this.sliderInterval);
        }
    }
}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/admin/devices/devicepreview.ts